import { styled } from '@bob/library'

export const StyledHoverMenu = styled.div`
  .flyout-wrapper {
    left: auto;
    right: 0px;
  }
`
